export default __webpack_public_path__ + "static/media/Medical.ab3d0ede.png";